<template>
  <div>
    <div v-if="loading" class="text-center">
      <small class="text-muted">Cargando...</small><br />
      <div class="lds-circle"><div></div></div>
    </div>
    <div v-else>
      <transition appear name="slide-fade">
        <div>
          <div>
            <h4>{{ categoria.categoria }}</h4>
            <span>{{ aliados.length }} aliados disponibles</span>
          </div>
          <div>
            <div class="row">
              <div
                v-for="(aliado, index_aliado) in aliados"
                v-bind:key="index_aliado"
                class="col-lg-4 col-12"
              >
                <router-link v-bind:to="'/aliado/' + aliado.id_aliado">
                  <div class="card card-body shadow">
                    <div
                      v-if="aliado.pieza_app != null"
                      class="about-company"
                      style="margin-top: 10px"
                    >
                      <img
                        class="rounded"
                        v-bind:src="aliado.pieza_app"
                        v-bind:alt="aliado.nombre_aliado"
                      />
                    </div>
                    <div class="row mt-3">
                      <div class="col-3">
                        <img
                          v-if="aliado.logo_app == null"
                          src="https://reddytech.com.co/api/assets/images/logo_aliado.png"
                          alt="logo"
                          style="max-width: 5em"
                        />
                        <img
                          v-else
                          v-bind:src="aliado.logo_app"
                          v-bind:alt="aliado.nombre_aliado"
                          style="max-width: 5em"
                        />
                      </div>
                      <div class="col-9">
                        <h6 class="item-title">
                          <router-link
                            v-bind:to="'/aliado/' + aliado.id_aliado"
                            class="text-primary text-uppercase"
                            >{{ aliado.nombre_aliado }}</router-link
                          >
                        </h6>
                        <div class="d-flex align-items-center text-muted mb-0">
                          <div v-if="aliado.sucursal!=null" class="text-capitalize">
                            <i class="fas fa-map-marker-alt me-1"></i>   {{aliado.sucursal.sucursal}}
                          </div>
                        </div>
                        <div>
                          
                          <div class="d-flex align-items-center text-muted mb-0">
                          Zona
                          <span v-if="aliado.zona == 1" class="ms-1">
                            Norte</span
                          >
                          <span v-if="aliado.zona == 2" class="ms-1"> Sur</span>
                          <span v-if="aliado.zona == 3" class="ms-1">
                            Este</span
                          >
                          <span v-if="aliado.zona == 4" class="ms-1">
                            Oeste</span
                          >
                          <span v-if="aliado.zona == 5" class="ms-1">
                            Centro</span
                          >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Categoria",
  metaInfo: {
    title: "Categoría - Reddy App",
  },
  data() {
    return {
      loading: true,
      loading_puntos: true,
      id_categoria: null,
      categoria: null,
      aliados: [],
    };
  },
  props: {
    session: Object,
    ciudad:Object
  },
  created: function () {
    this.id_categoria = this.$route.params.id_categoria;
    this.get_categoria();
    localStorage.setItem("tracks", this.id_categoria);
  },
  methods: {
    get_categoria: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
        params: {},
      };
      const vm = this;
      axios
        .get(this.$base_url + "admin/categoria/" + this.id_categoria, config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "<i class='fa fa-exclamation-circle'></i> Ups!",
              text: response.data.message,
            });
          } else {
            this.categoria = response.data.data.categoria;
            this.get_aliados();
          }
        })
        .catch((error) =>
          vm.$notify({
            type: "error",
            group: "foo",
            title: "<i class='fa fa-exclamation-circle'></i> Ups!",
            text: error,
          })
        )
        .finally();
    },
    get_aliados: function () {
      let id_sucursal = null;
      if(this.ciudad!=null){
        id_sucursal = this.ciudad.id_sucursal;
      }
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
        params: {
          categoria: this.id_categoria,
          estado_app: 1,
          id_sucursal:id_sucursal
        },
      };
      const vm = this;
      axios
        .get(this.$base_url + "aliados/aliados_app", config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "<i class='fa fa-exclamation-circle'></i> Ups!",
              text: response.data.message,
            });
          } else {
            this.aliados = response.data.data.aliados;
          }
          this.loading = false;
        })
        .catch((error) =>
          vm.$notify({
            type: "error",
            group: "foo",
            title: "<i class='fa fa-exclamation-circle'></i> Ups!",
            text: error,
          })
        )
        .finally();
    },
  },
  mounted: function () {},
};
</script>
